import 'reflect-metadata';

export const optionalMetadataKey = 'optional';

/**
 * Custom property decorator function used for checking existence of properties.
 * Function is not used anywhere as regular function call (optional()).
 * If property in class has optional decorator, then that property can have empty
 * (undefined) value (e.g. server did not send property).
 * It is always in pair with serializable decorator.
 *
 * @param {T} modelClass
 * @param {keyof T} propertyName
 *
 * ```typescript
 * class TestModel {
 *    @serializable
 *    @optional
 *    property: string;
 * }
 * ```
 */
export const optional = <T>(modelClass: T, propertyName: keyof T) => {
   Reflect.defineMetadata(optionalMetadataKey, true, (modelClass as any).constructor, propertyName as any);
};

/**
 * Function loops through all "props" in "serializeInfo" property on class (if exists) and
 * throws error if class property is not optional and value not exists.
 * Also, it recursively checks nested properties (objects or array of objects) of class.
 */
export const validateOptionalMobXSerializable = (modelClass: any, modelInstance: any) => {
   if (hasMobXSerializeDecorators(modelClass)) {
      const serializeInfoProps = modelClass.serializeInfo['props'];

      for (const prop in serializeInfoProps) {
         const isOptional = Reflect.getOwnMetadata(optionalMetadataKey, (modelInstance as any).constructor, prop);
         const value = modelInstance[prop];
         const valueExists = (value !== undefined && value !== null);

         if (!isOptional && !valueExists) {
            throw new Error(`A value does not exist for required field '${prop}' on class '${modelInstance.constructor.name}', deserialized data = '${JSON.stringify(modelInstance)}'`);
         }

         if (valueExists && value.constructor.serializeInfo) {
            validateOptionalMobXSerializable(value.constructor, value);
         }

         if (Array.isArray(value) && value.length) {
            value.map((item) => {
               if (item !== null && item !== undefined && item.constructor) {
                  validateOptionalMobXSerializable(item.constructor, item);
               }
            });
         }
      }
   }
};

/**
 * Helper function for checking if class use mobxjs serialization by existence of "props" in "serializeInfo" property.
 */
export const hasMobXSerializeDecorators = (modelClass: any): boolean => {
   const serializeInfo = modelClass.serializeInfo;

   return (serializeInfo && serializeInfo['props']);
};
